/**
 * /particuliers/aides/maprimerenov
 * ─────────────────────────────────────────────────────────────────
 * Guide éditorial complet (long-form) sur MaPrimeRénov’ 2026.
 * Composé du composant `MaPrimeRenovGuide` qui orchestre toutes les
 * sections (hero, résumé, 3 volets, bénéficiaires, travaux, plafonds
 * Anah, montants, MAR, cumul, démarches, FAQ, CTA final).
 *
 * Le contenu factuel est centralisé dans
 * `client/src/config/maprimerenov-content.ts`.
 */

import { MaPrimeRenovGuide } from '../../../../components/aides/MaPrimeRenovGuide';

export default function MaPrimeRenovPage() {
  return <MaPrimeRenovGuide />;
}
